var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 106.29,
    cy: 95.4,
    r: 12.11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.05 98.26 130.07 37.4 165.06 22.46 183.74 93.6 146.05 98.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "53.58 97.06 39.83 99.12 36.92 88.06 49.88 82.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.1,
    y1: 67.82,
    x2: 82.27,
    y2: 98.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "94.32 97.28 55.63 103.08 48.93 77.56 131.26 45.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.56,
    y1: 90.05,
    x2: 118.57,
    y2: 93.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.29,
    y1: 107.52,
    x2: 106.29,
    y2: 196.63
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.95 190.58 106.29 148.18 141.33 190.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.32,
    y1: 42.09,
    x2: 101.01,
    y2: 56.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.78,
    y1: 44.04,
    x2: 106.78,
    y2: 36.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/TELESCOPE.e5c2854f5d38ade4b5dd178f0bf52cfe.svg";
export { ForwardRef as ReactComponent };